export default {
  route: {
    dashboard: '首页',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: '导出 Excel',
    selectExcel: '导出 已选择项',
    mergeHeader: '导出 多级表头',
    uploadExcel: '上传 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    profile: '个人中心',
    personnel: '人员',
    personnelList: '劳务工人',
    temporaryPerson: '临时人员',
    manage: '项目',
    projectInfo: '项目信息',
    contractor: '参建单位',
    teamManagement: '班组管理',
    workTypeInfo: '工种列表',
    jobTypeInfo: '岗位列表',
    districtManagement: '区域管理',
    fleetManagement: '车队管理',
    device: '设备',
    faceRecognition: '人脸设备',
    dustNoise: '扬尘降噪',
    licensePlateRecognition: '车牌识别设备',
    towerCrane: '塔吊监控',
    lift: '升降机监控',
    monitor: '视频监控',
    distributionBox: '安全用电',
    statistics: '统计',
    identifyRecord: '识别记录',
    lPRRecord: '通行记录',
    dustRecord: '扬尘降噪记录',
    towerRecord: '塔吊监控记录',
    liftRecord: '升降机监控记录',
    distributionBoxRecord: '电箱监控记录',
    log: '日志',
    systemOperationLog: '系统操作日志',
    protocolReportingLog: '协议上报日志',
    screen: '投屏',
    realName: '劳务实名制',
    videoMonitor: '视频监控',
    vehicleManage: '车辆管理',
    safetyConstruction: '安全施工',
    epidemicControl: '疫情防控',
    projectPerson: '项目人员',
    abnormalPeople: '异常人员识别记录',
    idCardIdentification: '身份证识别记录',
    healthCodeIdentification: '健康码识别记录',
    helpDocument: '帮助文档',
    educate: '教育培训',
    educateList: '教育培训',
    whiteList: '车辆白名单',
    enterpriseAgreement: '政企协议',
    agreementList: '政企协议',
    comparisonLog: '云比对日志',
    managerList: '管理人员',
    approveStaff: '人员审批',
    wechatApp: '微信应用',
    visitePerson: '访客人员',
    blackList: '黑名单',
    attendanceReport: '考勤报表',
    noPermission: '无权限',
    personStatistics: '人员统计',
    customScreen: '自定义大屏',
    cloudAttendancePerson: '云考勤管理',
    ruleSetting: '规则设置',
    educateDevice: '签到设备',
    checkRecord: '签到记录',
    aiDevice: 'AI盒子',
    alarmRecord: '告警记录',
    statisticalRecord: '统计报表',
    faceRecord: '识别记录',
    aiRecord: 'AI记录',
    aiAnalyse: 'AI分析',
    aiStranger: 'AI陌生人',
    ai: '智能AI',
    aiCamera: 'AI摄像头',
    aiBox: '行为检测盒子',
    faceBox: '人脸识别盒子',
    electronicDisplay: '电子看板',
    led: 'LED屏',
    aiStatistics: 'AI人流统计',
    otherPersonelList: '其他人员',
    towerCraneDevice: '塔吊设备',
    liftDevice: '升降机设备',
    towerCraneDriver: '塔吊司机',
    dataRecording: '数据记录',
    salaryStatement: '工资报表',
    salary: '工资',
    bankCard: '银行卡',
    workContract: '劳务合同',
    payCalculation: '工资结算',
    enterpriseStatistics: '企业统计',
    liftDriver: '升降机司机',
    collectorDevice: '采集机',
    collectorRecord: '采集记录',
    inspectionPerson: '巡检人员',
    inspection: '施工巡检',
    inspectionDevice: '巡检设备',
    inspectionRecord: '巡检记录',
    workingHours: '进出工时'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小',
    dataScreen: '数据大屏',
    document: '帮助文档',
    taskCenter: '任务中心'
  },
  login: {
    title: '项目管理系统',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
    updatePassword: '修改密码'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description:
      '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  common: {
    close: '关闭',
    confirm: '确定'
  },
  personnel: {
    personnelList: '人员列表'
  },
  profile: {
    loginName: '当前账号',
    oldPassword: '当前密码',
    oldPasswordPlaceholder: '请输入当前密码',
    newPassword: '新登录密码',
    newPasswordPlaceholder: '请输入新的登录密码',
    confirmPassword: '确认新登录密码',
    avatar: '头像',
    name: '名称',
    namePlaceholder: '请输入用户名称',
    email: '邮箱',
    updateProfile: '更新资料',
    back: '返回'
  },
  dashboard: {
    todayEnterCount: '今日进场人数',
    todayExitCount: '今日出场人数',
    enterCount: '进场总人次',
    exitCount: '出场总人次',
    todaySiteCount: '今日场内人数',
    laborer: '劳务工人',
    manager: '管理人员',
    dutyCount: '在岗人数',
    exitNumber: '退场人数',
    blacklist: '黑名单',
    contractor: '参建单位',
    team: '班组',
    detail: '详细',
    ageSex: '年龄/性别',
    rank: '排名',
    count: '人数',
    deviceEnter: '设备入场',
    deviceOnlineRate: '设备在线率',
    monthAttendance: '月考勤人数'
  },
  manage: {
    base: '基础',
    edit: '编辑',
    cancle: '取消',
    save: '保存',
    submit: '提交',
    upload: '上报',
    organization: '所属组织',
    builderLicenseCode: '施工许可证编号',
    builderLicenseCodePlace: '请输入施工许可证编号',
    projectName: '项目名称',
    projectNamePlace: '请输入项目名称',
    projectStatus: '项目状态',
    projectStatusPlace: '请选择项目状态',
    projectType: '项目类型',
    projectTypePlace: '请选择项目类型',
    managerPhone: '项目经理手机号码',
    managerPhonePlace: '请输入区域地址项目经理手机号码',
    managerName: '项目经理',
    managerNamePlace: '请输入项目经理名称',
    address: '详细地址',
    addressPlace: '请输入详细地址',
    region: '所属地区',
    planEndDate: '计划竣工日期',
    planEndDatePalce: '计划竣工日期',
    startDate: '开工日期',
    startDatePlace: '选择开工日期',
    endDate: '竣工日期',
    endDatePlace: '选择竣工日期',
    remark: '备注',
    remarkPlace: '请输入备注',
    siteCode: '工地码',
    scanCode: '在公众号/小程序里扫描【工地码】识别项目',
    downloadCodeDesc: '下载工地码以便扫码使用',
    downloadCode: '下载工地码',
    companyName: '企业名称',
    companyNamePlace: '请输入企业名称',
    shortName: '企业简称',
    unifyCode: '统一社会信用代码',
    unifyCodePlace: '请输入统一社会信用代码',
    legalPersonName: '法人代表',
    regionName: '所属地区',
    companyTypeName: '参建单位类型',
    companyTypePlace: '请选择参建单位类型',
    lastUploadResultCn: '上报状态',
    operation: '操作',
    search: '查询',
    reset: '重置',
    refreshUploadStatus: '刷新上报状态',
    checkLog: '查看日志',
    teamName: '班组名称',
    teamNamePlace: '请输入班组名称',
    teamLeaderNamePlace: '请输入班组长',
    teamLeaderPhonePlace: '请输入联系电话',
    add: '添加',
    batchDelete: '批量删除',
    workType: '工种',
    job: '岗位',
    code: '编码',
    specialWorkType: '特殊工种',
    areaName: '区域名称',
    areaNamePlace: '请输入区域名称',
    areaAddress: '区域地址',
    areaAddressPlace: '请输入区域地址',
    checkDevice: '查看设备',
    accessAuthorizeHandle: '通行授权',
    checkAll: '全选',
    authorize: '授权',
    remove: '移除',
    deviceList: '设备列表',
    deviceInfo: '设备信息',
    deviceStatus: '设备状态',
    installAddress: '设备安装地址',
    deviceType: '设备类型',
    entryExitType: '进出类型',
    needBind: '微信应用需要绑定管理人员',
    scanCodeBind: '请用微信扫二维码授权绑定',
    safekeeping: '请妥善保管二维码避免泄露项目信息',
    binded: '已完成绑定',
    officialAccount: '公众号',
    forVisitorRegistartion:
      '用于访客登记，管理人员绑定账号后可接受访客的申请消息',
    downloadOfficialCode: '下载公众号二维码',
    applet: '小程序',
    checkPersonInfo: '查看劳务人员的考勤记录、资质证书、工资/借支、教育培训',
    downloadAppletCode: '下载小程序码',
    downloadPoster: '下载名片图片',
    phone: '手机号码',
    entourage: '随行人数',
    visitTime: '来访时间',
    leaveTime: '离开时间',
    reason: '来访事由',
    areaNote: '通行区域',
    screenName: 'screenName',
    screenNamePlace: '请输入屏幕名称',
    addScreen: '添加屏幕',
    unconfigured: '该屏幕还未配置内容',
    clickBottomConfig: '该屏幕还未配置内容',
    config: '配置',
    screenPixel: '屏幕比例',
    screenSize: '屏幕尺寸',
    screenWidth: '宽',
    screenHeight: '高',
    pixel: '像素',
    screenBgcolor: '背景颜色',
    saveConfig: '保存并配置屏幕',
    fullScreen: '全屏',
    cancelFullScreen: '取消全屏',
    preview: '预览',
    editScreen: '修改屏幕信息'
  },
  realName: {
    all: '全部',
    onDuty: '在岗',
    exit: '退场',
    contractorTeam: '参建单位/班组',
    personNamePlace: '请输入姓名',
    idcardNumberPlace: '请输入身份证号码',
    phonePlace: '请输入手机号码',
    personType: '人员类型',
    workTypePlace: '请选择工种',
    managerTypePlace: '请选择岗位',
    startDate: '开始日期',
    endDate: '结束日期',
    inStartDate: '进场开始日期',
    inEndDate: '进场结束日期',
    photo: '照片',
    gathered: '已采集',
    uncollected: '未采集',
    auditStatusPlace: '请选择状态',
    pending: '待审批',
    approved: '已审批',
    auditResultPlace: '请选择审批结果',
    approve: '审批通过',
    failApprove: '审批不通过',
    onJobStatusPlace: '请选择在岗状态',
    checkInStatus: '签到',
    checked: '已签到',
    notChecked: '未签到',
    checkOutStatus: '签退',
    signedOut: '已签退',
    notSignedOut: '未签退',
    addPerson: '添加人员',
    scanCodeAddPerson: '扫码添加人员',
    selectTrainers: '选择培训人员',
    batchAllotTeam: '批量分配班组',
    batchAllotWork: '批量分配工种',
    export: '导出',
    batchOperation: '批量操作',
    massExit: '批量退场',
    batchEncore: '批量返场',
    deletePersons: '删除选中人员',
    deleteAllPerson: '删除全部人员',
    batchEditTeam: '批量修改班组',
    batchEdit: '批量修改',
    moveToBlacklist: '移入黑名单',
    moreOperation: '更多操作',
    downloadTemplate: '下载模板',
    batchImportPerson: '正在批量导入人员信息...',
    importPerson: '导入人员',
    exportPerson: '导出人员',
    personName: '姓名',
    idcardNumber: '身份证号码',
    companyName: '参建单位',
    phoneNumber: '手机号码',
    visitTime: '来访时间',
    leaveTime: '离开时间',
    jobNumber: '工号',
    teamName: '班组',
    workerTypeName: '工种/岗位',
    applyDate: '申请日期',
    auditStatus: '状态',
    auditResult: '审批结果',
    auditTime: '审批时间',
    onJobStatus: '在岗状态',
    enterExitDate: '进退场日期',
    encore: '返场',
    approval: '审批',
    check: '查看',
    editPerson: '编辑人员',
    genderId: '性别',
    nationId: '民族',
    birthday: '出生日期',
    nativePlace: '户籍地址',
    idcardAuthOrg: '签发机关',
    idcardStartDate: '有效期限',
    region: '居住地',
    email: '邮箱',
    wechat: '微信',
    qq: 'QQ',
    companyId: '所属企业',
    cardNumber: '门禁卡号',
    devicePassword: '门禁密码',
    teamLeaderStatus: '班组长',
    trainStatus: '入场三级教育',
    devicePersonCode: '设备人员编号',
    inJobTime: '进场日期',
    outJobTime: '退场日期',
    emergencyContactName: '紧急联系人',
    emergencyContactPhone: '联系人电话',
    emergencyContactRelationId: '联系人关系',
    emergencyContactAddress: '联系人地址',
    personPhotoPath: '选择头像',
    idcardPersonPhotoPath: '手持身份证',
    idcardPhotoFrontPath: '身份证(国徽)',
    saveEdit: '保存并上报修改',
    saveAdd: '保存并上报新增',
    confirmMoveToPerson: '请确定是否将人员移回人员列表？',
    blackTime: '拉黑时间',
    blacklist: '拉黑人员',
    eventDescription: '事件描述',
    eventTime: '事件时间',
    eventPlace: '事件地点',
    eventPhotoPath: '事件图片',
    moveToPerson: '移回人员列表',
    labourPersonApply: '劳务人员申请',
    visitorApply: '访客申请',
    serialNumberManage: '序列号管理',
    cloudAttendanceRule: '云考勤规则',
    chooseCloudAttendance: '选择云考勤人员',
    serialNumber: '序列号',
    serialNumberPlace: '请输入设备序列号',
    online: '在线',
    offline: '离线',
    enter: '进场',
    out: '出场',
    machineType: '机器类型：',
    firmwareVersion: '固件版本：',
    versionName: '版本名称：',
    releaseTime: '发布时间：',
    adminCount: '管理员数：',
    userCount: '用户数：',
    faceCount: '人脸数：',
    fingerprintCount: '指纹数：',
    cardCount: '卡片数：',
    passwordCount: '密码数：',
    recordCount: '记录数：',
    manageRecordCount: '管理记录数：',
    photoRecordCount: '照片记录数：',
    lastOfflineTime: '最后离线时间',
    areaName: '设备所属区域',
    deviceConfig: '配置设备'
  }
}
